// extracted by mini-css-extract-plugin
export default {"headerConnection":"ConfigStep_headerConnection__2Gumb","connectionBox":"ConfigStep_connectionBox__1-Qyk","content":"ConfigStep_content__QhUzA"};